import addProfilesModal from "../../components/SimpleForm/Modals/AddProfilesModal";
import applicationDocumentsModal from "../SimpleForm/Modals/AddApplicationDocumentsModal";
import CreateGroupModal from "../SimpleForm/Modals/CreateGroupModal";

const componentLookup = (componentName) => {
  const components = {
    // content components
    applicationDocumentsModal: applicationDocumentsModal,

    // Profile modals used in 790A appendices
    addProfilesModal: addProfilesModal,

    // Modal used for creating a group
    createGroupModal: CreateGroupModal,
  };

  return components[componentName] || undefined;
};

export default componentLookup;
